var LuminanceIntensityUnit_1;
import { __decorate } from "tslib";
import { Unit } from './Unit';
import { SerializableObject } from '../../data/decorators';
/**
 * @category Unit
 */
let LuminanceIntensityUnit = LuminanceIntensityUnit_1 = class LuminanceIntensityUnit extends Unit {};
LuminanceIntensityUnit.CANDELA = new LuminanceIntensityUnit_1('candela', {
  baseName: 'luminanceintensity',
  aliases: ['cd']
});
LuminanceIntensityUnit = LuminanceIntensityUnit_1 = __decorate([SerializableObject()], LuminanceIntensityUnit);
export { LuminanceIntensityUnit };